import clsx from 'clsx'
import {LaraLogoExtended} from '~/ui/LaraLogoExtended'
import {TLink} from './TLink'
import {useTranslation} from 'react-i18next'

export function LaraLogoLink({className}: {className?: string}) {
  const {t} = useTranslation()

  return (
    <TLink
      aria-label={t('nav_pages.translate')}
      to="/translate"
      isNav
      className={clsx(className, 'w-fit outline-none')}
    >
      <LaraLogoExtended className="h-10 w-[6.75rem]" />
    </TLink>
  )
}
